import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact } from '@ionic/react';
import { IonReactHashRouter } from '@ionic/react-router';
import { Redirect, Switch, Route, useHistory } from 'react-router-dom';




import axios from 'axios';
import API_CONFIG from './config/api';
import SideMenu from './Menu';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';


/* Theme variables */
import './theme/variables.css';
import './App.css';
import Add from './pages/Add';
import View from './pages/View';
import ViewPoll from './pages/ViewPoll';
// Remove unused import
// import Registration from './pages/Registration';
import MultiVendorRegistration from './pages/MultiVendorRegistration';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Logout from './pages/Logout';
import Admin from './pages/Admin';
import OrgAdmin from './pages/OrgAdmin';
import SuperAdmin from './pages/SuperAdmin';
import UserDashboard from './pages/UserDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminUserEdit from './pages/AdminUserEdit';
import AdminPolls from './pages/AdminPolls';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminModeration from './pages/AdminModeration';
import AdminSettings from './pages/AdminSettings';
import AdminDocs from './pages/AdminDocs';
import AdminMembersManagement from './pages/AdminMembersManagement';
import PollAnalytics from './pages/PollAnalytics';
import AdminOrganizations from './pages/AdminOrganizations';
import GlobalHelp from './components/GlobalHelp';
import Maintenance from './pages/Maintenance';
import AdminPollSentiments from './pages/AdminPollSentiments';
import SplashScreen from './components/SplashScreen';

setupIonicReact();

const AppRoutes = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const history = useHistory();
  const location = useLocation();

  // Check if current page is an authentication page
  const isAuthPage = location.pathname.startsWith('/page/login') ||
    location.pathname.startsWith('/page/register') ||
    location.pathname.startsWith('/page/reset-password');

  useEffect(() => {
    // Session Recovery for 30-day persistence
    const userId = localStorage.getItem('userId');
    const loginTimestamp = localStorage.getItem('login_timestamp');
    const sessionUserId = sessionStorage.getItem('user_id');

    if (userId && loginTimestamp && !sessionUserId) {
      const now = new Date().getTime();
      const loginTime = parseInt(loginTimestamp);
      const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;

      if (now - loginTime < thirtyDaysInMs) {
        // Session is still valid, restore it
        sessionStorage.setItem('user_id', userId);

        // Also restore role and org if they exist
        const roleId = localStorage.getItem('roleId');
        if (roleId) sessionStorage.setItem('role_id', roleId);

        const organizationId = localStorage.getItem('organizationId');
        if (organizationId) sessionStorage.setItem('organization_id', organizationId);

        console.log('Session recovered from localStorage (valid for 30 days)');
        checkLoginStatus();
      } else {
        // Session expired, clear persistence
        localStorage.removeItem('userId');
        localStorage.removeItem('login_timestamp');
        localStorage.removeItem('roleId');
        localStorage.removeItem('organizationId');
        console.log('30-day session expired and cleared');
      }
    }
  }, []);

  console.log('ogonge HISTORY', history)
  const checkLoginStatus = useCallback(() => {
    const token = sessionStorage.getItem('user_id') || localStorage.getItem('userId');
    setIsLoggedIn(!!token);
  }, []);

  useEffect(() => {
    checkLoginStatus();
    // Also update role state
    const role = sessionStorage.getItem('role_id') || localStorage.getItem('roleId');
    setUserRole(role);
  }, [checkLoginStatus, history, location.pathname]);

  useEffect(() => {
    const fetchMaintenanceStatus = async () => {
      try {
        const response = await axios.get(API_CONFIG.MANAGE_SETTINGS);
        if (response.data.success) {
          setMaintenanceMode(!!response.data.settings.maintenance_mode);
        }
      } catch (e) {
        console.error("Failed to fetch maintenance status", e);
      }
    };
    fetchMaintenanceStatus();
  }, []);

  // If maintenance mode is ON and user is NOT Super Admin (1)
  // We allow access to login/logout so admins can still manage the system
  if (maintenanceMode && userRole !== '1' && !isAuthPage && location.pathname !== '/page/logout') {
    return <Maintenance />;
  }

  return (
    <>
      <GlobalHelp />
      {isAuthPage ? (
        /* For auth pages, render without split pane */
        <IonRouterOutlet id="main">
          <Switch>
            <Route path="/page/view" component={View} exact={true} />
            <Route path="/page/login" render={(props) => <Login {...props} checkLoginStatus={checkLoginStatus} />} />
            <Route path="/page/logout" render={(props) => <Logout {...props} checkLoginStatus={checkLoginStatus} />} />
            <Route path="/page/register" component={MultiVendorRegistration} exact={true} />
            <Route path="/page/register-org" component={MultiVendorRegistration} exact={true} />
            <Route path="/page/reset-password" component={ResetPassword} exact={true} />
            <Route path="/page/view/:id" component={ViewPoll} exact={true} />
            <Route path="/page/add" component={Add} exact={true} />

            {/* Admin Routes */}
            <Route path="/admin" component={Admin} exact={true} />
            <Route path="/org-admin" component={OrgAdmin} exact={true} />
            <Route path="/admin/users/:id/edit" component={AdminUserEdit} exact={true} />
            <Route path="/admin/users" component={AdminUsers} exact={true} />
            <Route path="/admin/members" component={AdminMembersManagement} exact={true} />
            <Route path="/admin/polls/:id/analytics" component={PollAnalytics} exact={true} />
            <Route path="/admin/polls/:id/sentiments" component={AdminPollSentiments} exact={true} />
            <Route path="/admin/polls" component={AdminPolls} exact={true} />
            <Route path="/admin/analytics" component={AdminAnalytics} exact={true} />
            <Route path="/admin/moderation" component={AdminModeration} exact={true} />
            <Route path="/admin/settings" component={AdminSettings} exact={true} />
            <Route path="/admin/docs" component={AdminDocs} exact={true} />

            <Route exact path="/" render={() => <Redirect to="/page/view" />} />
          </Switch>
        </IonRouterOutlet>
      ) : (
        /* For non-auth pages, render with split pane and side menu */
        <IonSplitPane contentId="main" when="(min-width: 992px)">
          <SideMenu refresh={isLoggedIn} />
          <IonRouterOutlet id="main">
            <Switch>
              <Route path="/page/view" component={View} exact={true} />
              <Route path="/page/login" render={(props) => <Login {...props} checkLoginStatus={checkLoginStatus} />} />
              <Route path="/page/logout" render={(props) => <Logout {...props} checkLoginStatus={checkLoginStatus} />} />
              <Route path="/page/register" component={MultiVendorRegistration} exact={true} />
              <Route path="/page/register-org" component={MultiVendorRegistration} exact={true} />
              <Route path="/page/reset-password" component={ResetPassword} exact={true} />
              <Route path="/page/reset-password" component={ResetPassword} exact={true} />
              <Route path="/page/view/:id" component={ViewPoll} exact={true} />
              <Route path="/page/add" component={Add} exact={true} />
              {/* Admin Routes */}
              <Route path="/admin" component={Admin} exact={true} />
              <Route path="/org-admin" component={OrgAdmin} exact={true} />
              <Route path="/admin/users/:id/edit" component={AdminUserEdit} exact={true} />
              <Route path="/admin/users" component={AdminUsers} exact={true} />
              <Route path="/super-admin" component={SuperAdmin} exact={true} />
              <Route path="/user-dashboard" component={UserDashboard} exact={true} />
              <Route path="/admin/members" component={AdminMembersManagement} exact={true} />
              <Route path="/admin/polls/:id/analytics" component={PollAnalytics} exact={true} />
              <Route path="/admin/polls/:id/sentiments" component={AdminPollSentiments} exact={true} />
              <Route path="/admin/polls" component={AdminPolls} exact={true} />
              <Route path="/admin/analytics" component={AdminAnalytics} exact={true} />
              <Route path="/admin/moderation" component={AdminModeration} exact={true} />
              <Route path="/admin/settings" component={AdminSettings} exact={true} />
              <Route path="/admin/docs" component={AdminDocs} exact={true} />
              <Route path="/admin/organizations" component={AdminOrganizations} exact={true} />

              <Route exact path="/" render={() => <Redirect to="/page/view" />} />
            </Switch>
          </IonRouterOutlet>
        </IonSplitPane>
      )}
    </>
  );
};

const App = () => {
  const [showSplash, setShowSplash] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Show splash screen for 2.5 seconds total
    const timer = setTimeout(() => {
      setFadeOut(true);
      // Wait for CSS transition animation to complete
      setTimeout(() => {
        setShowSplash(false);
      }, 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <IonApp>
      {showSplash && <SplashScreen fadeOut={fadeOut} />}
      <IonReactHashRouter>
        <AppRoutes />
      </IonReactHashRouter>
    </IonApp>
  );
};

export default App;
